import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=01b109a2"
import script from "./admin.ts?vue&type=script&lang=ts&external"
export * from "./admin.ts?vue&type=script&lang=ts&external"
import style0 from "./admin.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b109a2')) {
      api.createRecord('01b109a2', component.options)
    } else {
      api.reload('01b109a2', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=01b109a2", function () {
      api.rerender('01b109a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/admin.vue"
export default component.exports